import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";

export const dealReducer = (
  state: LoanState,
  action: PayloadAction<string>,
) => {
  state.dealId = action.payload;
};
